import { createRootRoute, HeadContent, Outlet } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { faviconHref, site } from "../config";
import { KeepRestoredScroll } from "../coras/KeepRestoredScroll";

const RouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import("@tanstack/react-router-devtools").then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    );

function RouteError() {
  return (
    <main style={{ margin: "auto", padding: "2rem", textAlign: "center" }}>
      <h1>This page did not load</h1>
      <p>
        Something went wrong on our side. Reload the page, or start again from
        the {site.title} home page.
      </p>
      <a href="/">Go to the home page</a>
    </main>
  );
}

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: site.title },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: site.favicons.map((favicon) => ({
      rel: "icon",
      href: faviconHref(favicon),
    })),
  }),
  errorComponent: RouteError,
  component: () => (
    <>
      <HeadContent />
      <Outlet />
      <KeepRestoredScroll />
      <Suspense>
        <RouterDevtools />
      </Suspense>
    </>
  ),
});
